import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowIcon, Button } from 'fronton-react';

type ModalNavigationButtonProps = {
  direction: 'left' | 'right';
  isVisible: boolean;
  onClick: () => void;
  className: string;
};

export const ModalNavigationButton: React.FC<ModalNavigationButtonProps> = ({
  direction,
  isVisible,
  onClick,
  className,
}) => {
  const { t } = useTranslation();
  if (!isVisible) return null;

  const isPrev = direction === 'left';

  return (
    <div className={className}>
      <Button
        data-qa={isPrev ? 'modal-prev' : 'modal-next'}
        aria-label={t(isPrev ? 'ui.buttons.prev' : 'ui.buttons.next')}
        kind="regular"
        variant="secondary"
        size="l"
        rounded
        iconOnly
        onClick={onClick}
      >
        <ArrowIcon direction={direction} />
      </Button>
    </div>
  );
};
